import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FieldInterventionBloc } from '@connect-services/client/blocs/field-intervention.bloc';
import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { FieldInterventionCreateEditModalData } from '@connect-services/client/models/create-edit-field-intervention-modal.model';
import { CustomDateAdapterService } from '@connect-services/client/services/custom-date-adapter.service';
import {
    ADAPTER_DATE_FORMATS,
    EN_DATE_FORMAT,
    TranslateService,
} from '@connect-services/client/services/translate.service';
import { ValidatorsService } from '@connect-services/client/services/validators.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FormService } from '@shared/client/services/form.service';

export class FieldInterventionUpdateScheduledEndDateForm extends FormGroup<{
    scheduledEndDate: FormControl<Date | null>;
}> {}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, MatNativeDateModule, RessourcesModule],
    providers: [
        { deps: [TranslateService], provide: DateAdapter, useClass: CustomDateAdapterService },
        { provide: MAT_DATE_FORMATS, useValue: ADAPTER_DATE_FORMATS },
    ],
    selector: 'app-update-date-field-intervention-modal',
    templateUrl: './update-date-field-intervention-modal.component.html',
})
export class UpdateDateFieldInterventionModalComponent implements OnInit {
    protected readonly customDateAdapterService = inject(CustomDateAdapterService);
    protected data: FieldInterventionCreateEditModalData = inject(MAT_DIALOG_DATA);
    protected dateFormatPlaceHolder = EN_DATE_FORMAT;
    protected dialogRef = inject(MatDialogRef<UpdateDateFieldInterventionModalComponent>);
    protected readonly fieldInterventionBloc = inject(FieldInterventionBloc);
    protected fieldInterventionUpdateEndDateForm!: FieldInterventionUpdateScheduledEndDateForm;
    protected readonly formService = inject(FormService);

    private readonly translateService = inject(TranslateService);

    public constructor() {
        this.dateFormatPlaceHolder = this.translateService.getDateFormat();
    }

    public ngOnInit(): void {
        this.initForm();
    }

    public onClickEvent(modalResult: ModalResultEnum): void {
        if (modalResult === ModalResultEnum.CANCEL) {
            this.dialogRef.close(null);

            return;
        }

        this.dialogRef.close(this.fieldInterventionUpdateEndDateForm);
    }

    private initForm(): void {
        this.fieldInterventionUpdateEndDateForm = new FieldInterventionUpdateScheduledEndDateForm({
            scheduledEndDate: new FormControl<Date | null>(this.data.scheduledEndDate ?? null, {
                validators: ValidatorsService.validateDateAfterNow(),
            }),
        });
    }
}
